export const assortmentArray = {
  sp: [
    {
      name: 'СП Ковбасний копчений',
      weight: '0,5',
      fat: '40%',
      img: new URL('../../images/assortment/img_sp3_@1x.png', import.meta.url),
      img2: new URL('../../images/assortment/img_sp3_@2x.png', import.meta.url),
    },
    {
      name: 'СП Ковбасний копчений (d71 d80 d75)',
      weight: '0,4/1,6/1,2',
      fat: '40%',
      img: new URL('../../images/assortment/img_sp1_@1x.png', import.meta.url),
      img2: new URL('../../images/assortment/img_sp1_@2x.png', import.meta.url),
    },
    {
      name: 'СП Ковбасний копчений у вісковій оболочці',
      weight: '0,9',
      fat: '40%',
      img: new URL('../../images/assortment/img_sp6_@1x.png', import.meta.url),
      img2: new URL('../../images/assortment/img_sp6_@2x.png', import.meta.url),
    },
    {
      name: 'СП Ковбасний копчений з шинкою',
      weight: '0,5',
      fat: '40%',
      img: new URL('../../images/assortment/img_sp2_@1x.png', import.meta.url),
      img2: new URL('../../images/assortment/img_sp2_@2x.png', import.meta.url),
    },
    {
      name: 'СП Ковбасний копчений з салямі у вісковій оболонці',
      weight: '1,0',
      fat: '40%',
      img: new URL('../../images/assortment/img_sp4_@1x.png', import.meta.url),
      img2: new URL('../../images/assortment/img_sp4_@2x.png', import.meta.url),
    },
    {
      name: 'СП Ковбасний копчений різаний',
      weight: '0,18/0,4',
      fat: '40%',
      img: new URL('../../images/assortment/img_sp5_@1x.png', import.meta.url),
      img2: new URL('../../images/assortment/img_sp5_@2x.png', import.meta.url),
    },
  ],
  sppp: [
    {
      name: 'СП пастоподібний Гауда',
      weight: '0,3',
      fat: '20%',
      img: new URL('../../images/assortment/img_spp1_@1x.png', import.meta.url),
      img2: new URL(
        '../../images/assortment/img_spp1_@2x.png',
        import.meta.url
      ),
    },
    {
      name: 'ПМСП пастоподібний Янтар',
      weight: '0,3',
      fat: '60%',
      img: new URL(
        '../../images/assortment/img_pspp2_@1x.png',
        import.meta.url
      ),
      img2: new URL(
        '../../images/assortment/img_pspp2_@2x.png',
        import.meta.url
      ),
    },
    {
      name: 'СП пастоподібний Янтар стакан',
      weight: '0,4',
      fat: '50%',
      img: new URL('../../images/assortment/img_spp2_@1x.png', import.meta.url),
      img2: new URL(
        '../../images/assortment/img_spp2_@2x.png',
        import.meta.url
      ),
    },
    {
      name: 'СП пастоподібний Янтар стакан',
      weight: '0,09',
      fat: '50%',
      img: new URL('../../images/assortment/img_spp4_@1x.png', import.meta.url),
      img2: new URL(
        '../../images/assortment/img_spp4_@2x.png',
        import.meta.url
      ),
    },
    {
      name: 'СП пастоподібний Янтар',
      weight: '3,0',
      fat: '50%',
      img: new URL('../../images/assortment/img_spp3_@1x.png', import.meta.url),
      img2: new URL(
        '../../images/assortment/img_spp3_@2x.png',
        import.meta.url
      ),
    },
    {
      name: 'ПМСП пастоподібний Янтар',
      weight: '0,5/1,0/3,0',
      fat: '60%',
      img: new URL(
        '../../images/assortment/img_pspp1_@1x.png',
        import.meta.url
      ),
      img2: new URL(
        '../../images/assortment/img_pspp1_@2x.png',
        import.meta.url
      ),
    },
  ],
  psp: [
    {
      name: 'ПМСП Ковбасний копчений Янтарний',
      weight: '1,2/0,3',
      fat: '40%',
      img: new URL('../../images/assortment/img_psp1_@1x.png', import.meta.url),
      img2: new URL(
        '../../images/assortment/img_psp1_@2x.png',
        import.meta.url
      ),
    },
    {
      name: 'ПМСП Ковбасний особливий Естонський',
      weight: '2,8',
      fat: '30%',
      img: new URL('../../images/assortment/img_psp2_@1x.png', import.meta.url),
      img2: new URL(
        '../../images/assortment/img_psp2_@2x.png',
        import.meta.url
      ),
    },
    {
      name: 'ПМСП Голандський новий',
      weight: '2,8/0,4',
      fat: '45%',
      img: new URL('../../images/assortment/img_psp3_@1x.png', import.meta.url),
      img2: new URL(
        '../../images/assortment/img_psp3_@2x.png',
        import.meta.url
      ),
    },
    {
      name: 'ПМСП Литовський',
      weight: '2,5',
      fat: '40%',
      img: new URL('../../images/assortment/img_psp6_@1x.png', import.meta.url),
      img2: new URL(
        '../../images/assortment/img_psp6_@2x.png',
        import.meta.url
      ),
    },
    {
      name: 'ПМСП Литовський з ароматом пряженого молока',
      weight: '2,5',
      fat: '40%',
      img: new URL('../../images/assortment/img_psp5_@1x.png', import.meta.url),
      img2: new URL(
        '../../images/assortment/img_psp5_@2x.png',
        import.meta.url
      ),
    },
    {
      name: 'ПМСП Моцарелла-Піца',
      weight: '0,9',
      fat: '30%',
      img: new URL('../../images/assortment/img_psp4_@1x.png', import.meta.url),
      img2: new URL(
        '../../images/assortment/img_psp4_@1x.png',
        import.meta.url
      ),
    },
  ],
};
